import { finish, error } from '../../../modules/fraud-and-compliance/actions/query';
import api from '../../../api';

export function request(dispatch, { id, index }) {
    let q = {
        perPage: 50
    };

    api.get('/fraud-and-compliance/' + id, q, { cache: true }).then(
        (data) => {
            dispatch(finish(id, data, index));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
